import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import { paymentMethodBlikChargeByCodeP24Transaction } from "../../actions/p24TransactionActions";

import logoPrzelewy24Blik from "../../../assets/logo-przelewy-24-blik.svg";

const floatRegExp = new RegExp('([0-9]+)$')



class P24BlikChargeByCodeForm extends React.Component {

    state = {
        blikCode: ''
    }

    componentDidMount() {

    }

    handleSubmit = async (e) => {
        e.preventDefault();

        //musimy zrobic w try/catch - bo dalej nie przejdzie - konczy sie dzialanie w tej metodzie
        try {
            await this.props.paymentMethodBlikChargeByCodeP24Transaction(this.props.transaction.id, this.state.blikCode);
        } catch (error) {
            console.log('blad - ale idziemy dalej')
        }

        this.props.onSubmit();

    };

    handleInputChange = e => {
        const target = e.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        //let blikCode = { blikCode: value };
        //this.setState({ [name]: value });


        //nie pozwalamy na pusty string
        //value === '' ||
        if (value === '' || floatRegExp.test(value)) {
            //przechodzi walidacje regex

            //obcinamy do dwoch miejsc po przecinku
            //const floatValue = parseFloat(value);
            //const floatValue2Decimals = floatValue.toFixed(2);

            //let transaction = { ...this.state.transaction, [name]: value };
            //this.setState({ transaction });


            this.setState({ [name]: value });
        }


    };

    handleCancel = e => {
        this.props.onCancel();
    };

    render() {



        return (
            <div className="w3-card-4" >
                <div className="w3-container w3-theme">
                    <h2 className="w3-center">
                        <FormattedMessage
                            id="app.p24BlikChargeByCodeForm.title"
                            defaultMessage="Pay by blik code"
                        />
                    </h2>
                </div>

                <br />

                <div className="w3-row-padding w3-xlarge">


                    <div className="w3-col s4 w3-right-align">
                        <img src={logoPrzelewy24Blik} style={{ height: '53px' }} alt="blik"></img>
                    </div>

                    <div className="w3-col s6">

                        {/*
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="app.p24BlikChargeByCodeForm.blikCode"
                                defaultMessage="blikCode"
                            />
                        </label>

                        <img src="https://static.przelewy24.pl/payment-form-logo/svg/181" style={{ height: '39px' }}></img>
*/}
                        <input
                            className="w3-input w3-round-large w3-border"
                            style={{ textAlign: 'center' }}
                            type="text"
                            name="blikCode"
                            onChange={this.handleInputChange}
                            value={this.state.blikCode}
                            maxLength="6"

                            placeholder="Wpisz 6-cyfrowy kod BLIK"
                        />


                    </div>

                    {/*
                    <div className="w3-third">
                        <span className="w3-text-pink w3-small">
                            <FormattedMessage
                                id="app.p24BlikChargeByCodeForm.blikCode.error"
                                defaultMessage="blikCode error"
                            />
                        </span>
                    </div>
*/}
                </div>

                <br />

                <form className="w3-container" onSubmit={this.handleSubmit}>

                    <div className="w3-bar">
                        <button
                            className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
                            type="submit"
                        >
                            <FormattedMessage
                                id="app.p24BlikChargeByCodeForm.submit"
                                defaultMessage="submit"
                            />
                        </button>
                        <button
                            className="w3-btn w3-theme-light w3-bar-item w3-right w3-margin-right"
                            type="reset"
                            onClick={this.handleCancel}
                        >
                            <FormattedMessage
                                id="app.p24BlikChargeByCodeForm.cancel"
                                defaultMessage="cancel"
                            />
                        </button>
                    </div>
                </form>
            </div>
        )
    }

}

P24BlikChargeByCodeForm.propTypes = {
    //dane wejsciowe obiektu do wypelnienia
    transaction: PropTypes.object.isRequired,
    //akcja zwrotna na anuluj
    onCancel: PropTypes.func.isRequired,
    //akcja zwrotna na zatwierdzenie
    onSubmit: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    p24MerchantPaymentMethodList: state.p24MerchantReducer.p24MerchantPaymentMethodList
});

const mapDispatchToProps = ({
    paymentMethodBlikChargeByCodeP24Transaction: paymentMethodBlikChargeByCodeP24Transaction
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(P24BlikChargeByCodeForm);